<template>
<div class="main-wrap">
  <div class="header-top">
    <slot name="logoshow"></slot>
    <slot name="btnlogo" v-if="hash != '/newRegister'"></slot>
  </div>
  <div class="header-bottom" v-if="hash != '/newRegister'">
    <ul class="naver-bar02 navBar_header">
      <!-- <li v-for="(item,index) in topNavList" :key="index" 
      :class="{'active':item.url && hash.search(item.url)!=-1 }"
      > -->
        <a v-for="(item,index) in topNavList" :class="{'active':item.url && hash.search(item.url)!=-1 }" :key="index + item.name"  href="javascript:void(0)" @click="routerJump(item)">
          <img class="Dimg" :src="item.logoImg" alt="">
          <img class="Aimg" :src="item.logoImg_" alt="">
          <span>{{$t(item.name)}}</span>
        </a>
      <!-- </li> -->
      <span class="spacer">|</span>
      <a v-for="(item,index) in topNavarr" :class="{'active':item.url && hash.search(item.url)!=-1 }" :key="index + item.name"  href="javascript:void(0)" @click="routerJump(item)">
          <img class="Dimg" :src="item.logoImg" alt="">
          <img class="Aimg" :src="item.logoImg_" alt="">
          <span>{{$t(item.name)}}</span>
      </a>
    </ul>
    <!-- <serve /> -->
  </div>
</div>
</template>

<script>
import serve from './serve.vue'
import { topNavList,topNavarr } from '../common/comdata.js'
import { mapState,mapMutations } from "vuex";
export default {
  components:{ serve },
  props:{
    propsDownFun:{
        type:Function,
        default:function(){}
    }
  },
  data(){
      return{
        topNavList,
        topNavarr
      }
  },
  computed:{
    ...mapState({
        customer_service_system_link: (state) =>state.FrontConfigList.customer_service_system_link,
        agent_url: (state) =>state.FrontConfigList.agent_url,    //代理链接
        UUID: (state) => state.UUID,
        isLogin: (state) => state.isLogin,
        gameMenuIsShow: (state) => state.linkList.gameMenuIsShow,
    }),
    hash(){
      return this.$route.fullPath
    },
  },
  methods:{
    ...mapMutations(["setshowloginfloat2"]),
    routerJump({ url,isGame }){
      if(isGame){
        // if(isGame == 'agency' && this.agent_url){
          // return window.open(this.agent_url)
        // }else 
        if(isGame == 'service' && this.customer_service_system_link){
           return window.open(this.customer_service_system_link)
        }else if(isGame =='APPDownload'){
          return  this.$emit('handleClose')
        }
      }else{
        if(url == '/team' && !this.isLogin){
          this.setshowloginfloat2(true)
        }else{
          this.$router.push(url)
        }
      }
    },
  },
}

</script>

<style lang="scss" scoped>
 .header-bottom{
  // background-image:url('./img/header_bottom_bg.jpg');
  // background-size: 100% 38px;
  // background-position: center top;
  line-height: 38px;
  // background-color: #161616;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  padding: 10px 0;
  margin-top: 20px;
}
.navBar_header{
  display: flex;
  align-items: center;
  
  a{ 
      color: rgba(255, 255, 255, 1);
      font-family: Roboto;
      font-weight: 300;
      font-size: 14px;
      line-height: 1.5;
      letter-spacing: 0px;
      text-align: left;
      text-decoration: none;
      margin: 0 12px;
      &.active {
          color: rgba(243, 184, 103, 1);
          text-transform: uppercase;
          border-bottom: 1px solid;
          padding-bottom: 5px;
      }
      &.active,&:hover{
        .Aimg{
          display: inline-block;
        }
        .Dimg{
          display: none;
        }
        color: rgba(243, 184, 103, 1);
      }
      img{
        vertical-align: sub;
        height: 20px;
        width: auto;
        margin-right: 5px;
      }
      .Aimg{
        display: none;
      }
  };
  .spacer{
    margin: 0 10px;
    color: rgba(255, 255, 255, 1);
  }
  &.naver-bar01{
    padding-left:25px;
    li{ margin-left:10px; }
    li a{ 
      font-size: 16px;
      .logoImg{
        display:inline-block;
        width:21px;
        height:21px;
        background-size: 100%;
        background-repeat: no-repeat;
        background-position-y:0%;
        vertical-align: middle;
        margin-top:-2px;
      }
    }
    // li{
    //   &:hover,&.active{ 
    //     a{
    //       // background:#fff;
    //       border-radius: 20px;
    //       font-family: Roboto-Black;
    //       // color: #13aef8;
    //       color: #bebf01;
    //       // .logoImg{ background-position-y:100%; }
    //     }
    //   }
    // }
  }
}
.main-wrap {
  min-width:1240px;
  width: 100%;
  position: relative;
  z-index:999;
  background-color: #211F1B;
  padding: 10px 0;
  .header-top {
    position: relative;
    padding:0 31px;
    height:40px;
    line-height: 40px;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    // background-color: #37573f;
    // background-image:url('./img/header_top_bg.jpg');
    // background-size: 100% 64px;
    // background-position: center top;
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/build902/components/Header/navBar.vue